import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-1" }
const _hoisted_2 = { class: "font-weight-bold" }
const _hoisted_3 = { class: "mb-1" }
const _hoisted_4 = { class: "font-weight-bold" }
const _hoisted_5 = { class: "mb-1" }
const _hoisted_6 = { class: "font-weight-bold" }
const _hoisted_7 = { class: "mb-1" }
const _hoisted_8 = { class: "font-weight-bold" }
const _hoisted_9 = { class: "font-weight-bold" }

import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import { formatDateTime } from '@/services/functions';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'DisplayDeliveryPlanInformation',
  props: {
    deliveryPlan: {}
  },
  setup(__props: any) {

const props = __props;

function changeFormat(dateTime: string | null) {
  return dateTime ? formatDateTime(new Date(dateTime)) : '';
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createBlock(_component_v_col, { cols: "12" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.splitForm.tripId')), 1),
        _createTextVNode(" " + _toDisplayString(props.deliveryPlan?.delivery_plan_id), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.splitForm.carNumber')), 1),
        _createTextVNode(" " + _toDisplayString(props.deliveryPlan?.car_number), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.splitForm.driver')), 1),
        _createTextVNode(" " + _toDisplayString(props.deliveryPlan?.driver?.full_name), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.alterLeavingOrReturning.leavingDateTime')), 1),
        _createTextVNode(" " + _toDisplayString(changeFormat(props.deliveryPlan?.leaving_warehouse_date_time ?? null)), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.alterLeavingOrReturning.returningDateTime')), 1),
        _createTextVNode(" " + _toDisplayString(changeFormat(props.deliveryPlan?.returning_warehouse_date_time ?? null)), 1)
      ])
    ]),
    _: 1
  }))
}
}

})